import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { faFacebook, faTwitter, faYoutube, faInstagram, faPinterest } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import FAQ from '../components/FAQ'; // Make sure this path is correct
const FAQs = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>Find Your Perfect Pet to Rehome or Adopt Near You</title>
                <meta name="description" content="Browse pets available for rehoming and adoption near you. Connect directly with owners and rescue organizations to find your new furry friend." />
                <meta name="keywords" content="rehome pets, adopt pets, dogs for adoption, cats for adoption, puppies for adoption, kittens for adoption, pet rescue near me, pet adoption near me" />

            </Helmet>

            {/* Hero Section */}
            <section className="hero-section py-5 ">
                <FAQ></FAQ>
            </section>
        </>
    );
};

export default FAQs;